import { ImagePosition } from "../../enum/enumImagePosition";
import { SmartComponentType } from "../../enum/enumSmartComponentType";
import { ViewMode } from "../../enum/enumViewMode";
import { SmartComponentKind } from "./smart-component-kind";

/**
 * Smart component
 */
export class SmartComponent {
  public id: number;
  public idSmartComponentKind: SmartComponentType;
  public idSmartComponentKindNavigation: SmartComponentKind[];
  public informalName: string;
  public name: string;
  public viewMode: ViewMode = 0;
  public summary: boolean = false;
  public associated: boolean = false;
  public imported: boolean = false;
  public order: number = 0;
  public xCoord: string;
  public yCoord: string;
  public textPosition: ImagePosition | "";
  public showText: boolean;
  public textColor: string;
  public rotationIcon: number = 0;
  public zoom: number = 100;

  constructor(controlType?: any) {
    // used for assign type to instance of object
    if (controlType) {
      Object.assign(this, controlType);
    }
  }
}
